import { render, staticRenderFns } from "./checkBlock.vue?vue&type=template&id=975565f6&scoped=true&"
import script from "./checkBlock.vue?vue&type=script&lang=js&"
export * from "./checkBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975565f6",
  null
  
)

export default component.exports